import { inject, observer } from "mobx-react";
import * as React from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
  CardHeader,
  CardBody,
  Alert,
} from "reactstrap";

import { IArke, SiteResponseV1 } from "@intreba/arke-api-client";
import { Spinner } from "../../../../components";
import { CannotEditWarning } from "../CannotEditWarning";
import { withTranslation, WithTranslation } from "react-i18next";
import { PicturesState } from "./PicturesState";

interface InjectedProps extends IProps {
  itemContainer: { site: SiteResponseV1 };
  arke: IArke;
}

interface IProps extends WithTranslation {}

@inject("itemContainer", "arke")
@observer
class PictureSettingsContent extends React.Component<IProps, {}> {
  private settingsState: PicturesState;
  public constructor(props: any) {
    super(props);
    this.settingsState = new PicturesState(
      this.injectedprops.t,
      this.injectedprops.arke,
      this.injectedprops.itemContainer.site
    );
  }
  private get injectedprops() {
    return this.props as InjectedProps;
  }
  public async componentDidMount() {
    await this.settingsState.load();
  }
  public render() {
    const t = this.injectedprops.t!;
    return (
      <>
        <CardHeader tag="div">
          <Row style={{ marginBottom: "1rem" }}>
            <Col md={12}>
              <h2>{t("title")}</h2>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={() => {}}>
                <CannotEditWarning state={this.settingsState} />
                <Row>
                  <Col>
                    <Alert color="warning">{t("contactSupport")}</Alert>
                  </Col>
                </Row>
                <FormGroup row={true}>
                  <Label for="name" lg={2}>
                    {t("enableVisitPicturesLabel")}
                  </Label>
                  <Col lg={10}>
                    <Input
                      type="checkbox"
                      name="enableVisitPictures"
                      id="enableVisitPictures"
                      checked={this.settingsState.enabled}
                      disabled={true}
                    />
                    <FormText color="muted">
                      {t("enableVisitPicturesHelp")}
                    </FormText>
                  </Col>
                </FormGroup>
                <FormGroup row={true}>
                  <Label for="name" lg={2}>
                    {t("visitPictureRetentionLabel")}
                  </Label>
                  <Col lg={10}>
                    <Input
                      type="number"
                      name="visitPictureRetention"
                      id="visitPictureRetention"
                      value={this.settingsState.picturesRemovalDays}
                      disabled={true}
                    />
                    <FormText color="muted">
                      {t("visitPictureRetentionHelp")}
                    </FormText>
                  </Col>
                </FormGroup>
                <FormGroup row={true}>
                  <Label for="name" lg={2}>
                    {t("maxPictureCountLabel")}
                  </Label>
                  <Col lg={10}>
                    <Input
                      type="number"
                      name="maxPictureCount"
                      id="maxPictureCount"
                      value={this.settingsState.maxPictureCount}
                      disabled={true}
                    />
                    <FormText color="muted">
                      {t("maxPictureCountHelp")}
                    </FormText>
                  </Col>
                </FormGroup>
              </Form>
              {this.settingsState.loading && <Spinner />}
            </Col>
          </Row>
        </CardBody>
      </>
    );
  }
}

const PictureSettings = withTranslation("sitesettingspictures")(
  PictureSettingsContent
);
export { PictureSettings };
